<div class="content-wrapper">
    <div class="content-body">

        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <div class="col-md-8 col-lg-6">
            <div class="card-detail" *blockUI="'section-block'">
                <div class="card-detail-body">
                    <div class="d-flex justify-content-between align-items-center">
                        <h2 class="card-title" style="font-style: italic; font-weight: bold;">
                            {{ device?.modelName?.toUpperCase() }} {{ device?.brandName?.toUpperCase() }}
                        </h2>
                        <div class="card-subtitle text-end">
                            <p>{{ device?.typeName }}</p>
                            <p>{{ device?.cratedAt | date: 'dd/MM/yyyy' }}</p>
                        </div>
                    </div>
                    <p class="card-subtitle">
                        Şirket: <strong>{{ device?.companyName }}</strong>
                    </p>
                    <p class="card-subtitle">
                        Yetkili: <strong>{{ device?.name }} {{ device?.lastName }}</strong>
                    </p>
                </div>
                <div class="device-info">
                    <span><strong>Seri No:</strong> {{ device?.seriNo }}</span>
                    <!-- <span>Garanti Durumu: {{ device?.isWarrantyStatus ? 'Geçerli' : 'Geçersiz' }}</span>
                    <span>Cihaz Durumu: {{ device?.isDeviceStatus ? 'Aktif' : 'Pasif' }}</span> -->
                    <span><strong>Envanter No:</strong> {{ device?.inventoryNumber }}</span>
                </div>
            </div>
        </div>
    </div>
</div>